import TicketService from "services/ticket";
import { IconButton, Stack, Typography, Box } from "@mui/material";
import NF from "assets/nf.png";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";
import { IconCopy } from "../../../../Icons/IconCopy";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useContext } from "react";
import ApiContext from "api";
import ClienteService from "services/cliente";
import { toast } from "react-toastify";

export default function Ticket({ ticket }) {
  const [copy, setCopy] = useState(false);

  const { ConsigazApi } = useContext(ApiContext);
  const ticketStatus = TicketService.getTicketStatus(ticket);

  const bgColor =
    ticketStatus === "avencer" || ticketStatus === "open"
      ? "#FF9703"
      : ticketStatus === "paid"
      ? "#00A326"
      : ticketStatus === "outdated"
      ? "#EA4C4B"
      : "#A2A2A2";

  const sendByEmail = () => {
    const { email, segmento } = ClienteService.localEntrega;
    const { email: emailContato } = ClienteService.industrialContato || {};

    if (
      (segmento !== "INDUSTRIAL" && !email) ||
      (segmento === "INDUSTRIAL" && !emailContato)
    ) {
      toast.error(
        "Parece que você não tem e-mail cadastrado. Entre no perfil e cadastre agora mesmo para poder receber suas contas!"
      );
      return null;
    }

    if (!ticket) return null;

    ConsigazApi.shareTicket(
      ticket["cod_estab"] ?? ticket["cod-estabel"],
      ticket["cod_ser_docto"] ?? ticket["serie"],
      ticket["cod_tit_acr"] ?? ticket["nr-nota-fis"]
    ).then(
      () =>
        toast.success(
          `A nota fiscal foi enviada para ${
            segmento === "INDUSTRIAL" ? emailContato : email
          }`
        ),
      () => toast.error("Erro ao enviar a nota fiscal.")
    );
  };

  console.log(ticketStatus);

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mb={"24px"}
      >
        <Typography fontSize={"36px"} fontWeight={800} color={"#03A9F5"}>
          Nota Fiscal
        </Typography>
        <Stack
          borderRadius={"32px"}
          bgcolor={bgColor}
          textAlign={"center"}
          padding={"16px"}
        >
          <Typography fontSize={"16px"} fontWeight={600} color={"#FFFFFF"}>
            Nota fiscal{" "}
            {ticketStatus === "avencer" || ticketStatus === "open"
              ? "a vencer"
              : ticketStatus === "paid"
              ? "paga"
              : ticketStatus === "outdated"
              ? "vencida"
              : "cancelada/devolvida"}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction={"row"} gap={1} alignItems={"center"}>
        {copy ? (
          <Stack justifyContent={"center"} alignItems={"center"} mr={0.35}>
            <CheckIcon
              sx={{
                fontSize: "25px",
                color: "#053462",
              }}
            />
            <Typography fontSize={"12px"} fontWeight={700} color="#053462">
              copiado
            </Typography>
          </Stack>
        ) : (
          <IconButton
            onClick={() => {
              navigator.clipboard.writeText(
                ticket["nr-nota-fis"],
                setCopy(true)
              );
            }}
          >
            <IconCopy />
          </IconButton>
        )}{" "}
        <Stack>
          <Typography fontSize={"14px"} fontWeight={600} color="#636363">
            Código da nota fiscal
          </Typography>
          <Typography fontSize={"24px"} fontWeight={700} color="#053462">
            {ticket["nr-nota-fis"]}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        position={"relative"}
        height={"216px"}
        border={"2px solid #05346299"}
        borderRadius={"8px"}
        mt={"24px"}
        justifyContent={"center"}
      >
        <Box
          component="img"
          src={NF}
          alt="Nota Fiscal Genérica"
          sx={{
            maxHeight: "100%",
            maxWidth: "100%",
            borderRadius: "8px",
            opacity: 0.5,
          }}
        />
        <Stack
          borderRadius={"8px"}
          bgcolor={ticketStatus === "cancel" ? "#EA4C4BA3" : "#32323287"}
          padding={"10px"}
          position={"absolute"}
          right={"45%"}
          onClick={() => {
            if (ticketStatus !== "cancel") {
              window.open(
                `/danfe-pdf?acao=ArquivoNF&titulo=${ticket["cod-estabel"]}|${ticket["serie"]}|${ticket["nr-nota-fis"]}`
              );
            }
          }}
        >
          {ticketStatus === "cancel" ? (
            <CloseIcon
              sx={{
                color: "#FFFFFF",
                fontSize: "50px",
              }}
            />
          ) : (
            <SearchIcon
              sx={{
                color: "#FFFFFF",
                cursor: "pointer",
                fontSize: "50px",
              }}
            />
          )}
        </Stack>
      </Stack>
      <Stack gap={"24px"} mt={"24px"} direction={"row"}>
        <Button
          variant="contained"
          color="secondary"
          disabled={ticketStatus === "cancel"}
          fullWidth
          sx={{
            height: "55px",
            color: "#fff",
          }}
          onClick={() => sendByEmail()}
        >
          Compartilhar por email
        </Button>
        <Button
          variant="contained"
          color="secondary"
          disabled={ticketStatus === "cancel"}
          fullWidth
          sx={{
            height: "55px",
            color: "#fff",
          }}
          onClick={() => ConsigazApi.xmlNFDownload(ticket)}
        >
          Baixar XML
        </Button>
      </Stack>
    </>
  );
}
